<script>
import {mapState, mapActions} from 'vuex';
import {WindowService} from "../../services/WindowService";
import NavigationMenuFilter from '../NavigationMenuFilter/NavigationMenuFilter.vue';
import SelectLanguage from '../SelectLanguage/SelectLanguage.vue';
import KeyValueMenu from '../KeyValueMenu/KeyValueMenu.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';

export default {
    components: {
        NavigationMenuFilter,
        SelectLanguage,
        KeyValueMenu,
        DropdownMenu
    },
    data() {
        return {
            languages: this.$locale.getValidLanguages()
        }
    },
    computed: {
        ...mapState({
            minimized: state => state.nav.minimized,
            language: state => state.nav.language.value,
            supplier: state => state.auth.supplier,
            user: state => state.auth.user
        })
    },
    created () {
        this.$locale.change(this.language);
    },
    methods: {
        ...mapActions({
            setMinimizedNav: 'nav/setMinimizedNav'
        }),
        showHideNav ($event) {
            if (
                $event.target.id === 'navigation-menu'
                && WindowService.width() < WindowService.breakpoints.lg
            ) {
                this.setMinimizedNav(true);
            }
        }
    }
}
</script>

<template>
    <div id="navigation-menu"
         :class="{'navigation-menu--minimized': minimized}"
         class="navigation-menu"
         @click="showHideNav($event)">
        <div class="navigation-menu__inner">
            <div class="navigation-menu__body">
                <ul class="navigation-menu__list">
                    <li class="navigation-menu__item">
                        <router-link to="/dashboard"
                                     active-class="navigation-menu__link--active"
                                     class="navigation-menu__link navigation-menu__link--home"
                                     exact>
                            <span class="navigation-menu__link-text">{{ $t('navigation-menu.items.dashboard') }}</span>
                        </router-link>
                    </li>
                    <li class="navigation-menu__item">
                        <router-link to="/dashboard/stats"
                                     active-class="navigation-menu__link--active"
                                     class="navigation-menu__link navigation-menu__link--statistics">
                            <span class="navigation-menu__link-text">{{ $t('navigation-menu.items.stats') }}</span>
                        </router-link>
                    </li>
                    <li class="navigation-menu__item">
                        <router-link to="/dashboard/booking"
                                     active-class="navigation-menu__link--active"
                                     class="navigation-menu__link navigation-menu__link--booking">
                            <span class="navigation-menu__link-text">{{ $t('navigation-menu.items.booking') }}</span>
                        </router-link>
                    </li>
                    <li v-if="user.contractManager || (supplier && !supplier.xmlSupplier)" class="navigation-menu__item">
                        <router-link to="/dashboard/allocation"
                                     active-class="navigation-menu__link--active"
                                     class="navigation-menu__link navigation-menu__link--allocation">
                            <span class="navigation-menu__link-text">{{ $t('navigation-menu.items.allocation') }}</span>
                        </router-link>
                    </li>
                    <li v-if="user.contractManager" class="navigation-menu__item">
                        <router-link to="/dashboard/contract-management"
                                     active-class="navigation-menu__link--active"
                                     class="navigation-menu__link navigation-menu__link--contractManagement">
                            <span class="navigation-menu__link-text">{{ $t('navigation-menu.items.contract') }}</span>
                        </router-link>
                    </li>
                    <li v-if="!user.contractManager" class="navigation-menu__item">
                        <router-link :to="{name: 'contractList', params: {supplierId: supplier.id}}"
                                     active-class="navigation-menu__link--active"
                                     class="navigation-menu__link navigation-menu__link--contract">
                            <span class="navigation-menu__link-text">{{ $t('navigation-menu.items.contract') }}</span>
                        </router-link>
                    </li>
                    <li v-if="!minimized" class="navigation-menu__select-supplier">
                        <navigation-menu-filter/>
                    </li>
                    <li v-if="languages.length > 1" class="navigation-menu__select-language">
                        {{ $t('navigation-menu.language') }}
                        <select-language/>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/NavigationMenu/NavigationMenu.vue